import * as React from 'react';
import Dialog from './design-system/Dialog';

interface IModalProps {
  visible?: boolean;
  closeModal: VoidFunction;
  width?: string;
  title?: string | React.ReactElement<any>;
  id?: string;
  children?: React.ReactNode;
  height?: string;
  className?: string;
  closeIcon?: boolean;
}

const Modal: React.FC<IModalProps> = ({
  visible,
  closeModal,
  width,
  title,
  id,
  children,
  className = '',
  height,
  closeIcon = true,
}) => (
  <div id={id}>
    <Dialog
      open={!!visible}
      id={'modal'}
      title={title}
      width={width}
      onClose={closeModal}
      className={className}
      height={height}
      closeIcon={closeIcon}
    >
      {children}
    </Dialog>
  </div>
);
export default Modal;
